// src/Dashboard/pages/user/Boutique/components/BoutiqueKpis.jsx

import React from "react";
import {
  FaBoxes,
  FaCheckCircle,
  FaLayerGroup,
  FaShoppingCart,
  FaTimesCircle,
} from "react-icons/fa";

import { formatEUR } from "../utils/boutiqueUtils";

export default function BoutiqueKpis({ stats, loading }) {
  const cards = [
    {
      key: "total",
      label: "Articles",
      icon: FaBoxes,
      value: stats?.total ?? 0,
      tone: "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300",
    },
    {
      key: "available",
      label: "Disponibles",
      icon: FaCheckCircle,
      value: stats?.available ?? 0,
      tone: "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
    },
    {
      key: "outOfStock",
      label: "Épuisés",
      icon: FaTimesCircle,
      value: stats?.outOfStock ?? 0,
      tone: "border-red-200 bg-red-50 text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300",
    },
    {
      key: "categories",
      label: "Catégories",
      icon: FaLayerGroup,
      value: stats?.categories ?? 0,
      tone: "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",
    },
    {
      key: "cart",
      label: "Panier",
      icon: FaShoppingCart,
      value:
        stats?.cartUnits > 0
          ? `${stats.cartUnits} · ${formatEUR(stats.cartTotal)}`
          : "Vide",
      tone: "border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-800/60 dark:text-slate-200",
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
      {cards.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.key}
            className={`rounded-[24px] border px-4 py-4 shadow-sm ${card.tone}`}
          >
            <div className="flex items-center justify-between gap-3">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white/70 dark:bg-white/10">
                <Icon />
              </span>

              <span className="text-xl font-bold sm:text-2xl">
                {loading ? "…" : card.value}
              </span>
            </div>

            <p className="mt-3 text-[11px] font-bold uppercase tracking-[0.16em] opacity-80">
              {card.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}